import { Grid } from "@mui/material";
import { TextInput } from "components";
import { withForm, WrapperProps } from "hoc";
import { FC } from "react";
import { UtilitaireModal } from "../UtilitaireModal";

const Form: FC<WrapperProps> = (props) => {
  return (
    <UtilitaireModal
      {...props}
      onClose={props.onBack}
      title={
        props.isEditMode ? "Mise à jour du fournisseur" : "Ajouter un fournisseur"
      }
    >
      <Grid container spacing={3}>
        <Grid item xs={12} md={6}>
          <TextInput label="Nom *" name="nom" />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextInput label="Code *" name="code" />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextInput label="Téléphone" name="telephone" />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextInput label="Email" name="email" />
        </Grid>
        <Grid item xs={12}>
          <TextInput label="Adressee" name="adresse" />
        </Grid>
      </Grid>
    </UtilitaireModal>
  );
};

export const FournisseurModal = withForm(Form);
